import { Outlet } from "react-router-dom";
import { Header } from "@/components/organisms/Header";
import { BottomNavigation } from "@/components/organisms/BottomNavigation";
import { FirebaseConfigWarning } from "@/components/organisms/FirebaseConfigWarning";
import { PageTransition } from "@/animations/PageTransition";

/**
 * Layout usado por todas as rotas autenticadas (Home, Jogos, Grupos,
 * Ranking, Perfil e futuramente Grupo/Admin). Header fixo no topo,
 * BottomNavigation fixa embaixo, conteúdo rolável no meio.
 */
export function AppShell() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header />
      <FirebaseConfigWarning />
      <main className="container flex-1 pb-24 pt-4">
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>
      <BottomNavigation />
    </div>
  );
}
